import React, { useContext } from 'react';
import ReactSelect from 'react-select';
import GlobalContext from '../utils/GlobalContext';

const Select = ({ placeholder, ...props }) => {
  const { locales } = useContext(GlobalContext);

  const finalPlaceholder = placeholder || locales.common.selectPlaceholder;

  return <ReactSelect placeholder={finalPlaceholder} {...props} />;
};

export default Select;
